import React from "react";
import { ArrowUp, ArrowDown, Minus, Sparkle } from "lucide-react";

export const LABEL = "font-mono-data text-[10px] uppercase tracking-wider text-[#9FA1A4]";

export function PositionBadge({ position, depth, testid }) {
  if (!position) return <span data-testid={testid} className="font-mono-data text-xs text-[#c4c5cc]" title={`Not in top ${depth || 100}`}>—</span>;
  const tone = position <= 3 ? "bg-[#723FFF] text-white" : position <= 10 ? "bg-[#EDE7FF] text-[#5b2fd6]" : position <= 20 ? "bg-[#F6F6FD] text-[#06060C]" : "text-[#595D62]";
  return <span data-testid={testid} className={`inline-flex min-w-[34px] justify-center rounded-full px-2 py-0.5 font-mono-data text-xs font-semibold ${tone}`}>{position}</span>;
}

export function ChangeChip({ value, testid }) {
  if (value === null || value === undefined) return <span data-testid={testid} className="text-[#c4c5cc] text-xs">—</span>;
  if (value === "new") return <span data-testid={testid} className="inline-flex items-center gap-0.5 text-[11px] font-medium text-[#723FFF]"><Sparkle className="h-3 w-3" />new</span>;
  if (value === "lost") return <span data-testid={testid} className="text-[11px] font-medium text-rose-600">lost</span>;
  if (value === 0) return <span data-testid={testid} className="inline-flex items-center text-[#c4c5cc]"><Minus className="h-3 w-3" /></span>;
  const up = value > 0;
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-0.5 font-mono-data text-xs font-medium ${up ? "text-[#1f9d55]" : "text-rose-600"}`}>
      {up ? <ArrowUp className="h-3 w-3" /> : <ArrowDown className="h-3 w-3" />}{Math.abs(value)}
    </span>
  );
}

export function Stat({ label, value, sub, testid }) {
  return (
    <div data-testid={testid} className="rounded-2xl border border-[#EEEFEF] bg-white px-4 py-3.5">
      <p className={LABEL}>{label}</p>
      <p className="font-display text-2xl font-semibold text-[#06060C] mt-1">{value ?? "—"}</p>
      {sub && <p className="text-[11px] text-[#9FA1A4] mt-0.5">{sub}</p>}
    </div>
  );
}

export const shortUrl = (u) => { try { const x = new URL(u); return x.pathname === "/" ? x.hostname : x.pathname; } catch { return u || ""; } };
